import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwitchComponent } from './switch.component';
import { SwitchRoutingModule } from './switch-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {InputSwitchModule} from "../../component/ing/inputswitch/inputswitch";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SwitchRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    InputSwitchModule,
    TableModule
  ],
  declarations: [SwitchComponent]
})
export class SwitchDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/switch/switchDemo.module.ts